import { components } from "app/components/MatxTheme/components";

// Soft, low-opacity shadow ramp (25 entries, indices 0-24) for MUI `elevation`.
// Named shadows used by components live in `app.shadow.*` below.
const buildSoftShadows = () => {
  const ramps = [
    "none",
    "0px 1px 2px rgba(15, 23, 42, 0.05)",
    "0px 1px 3px rgba(15, 23, 42, 0.06)",
    "0px 1px 3px rgba(15, 23, 42, 0.07), 0px 1px 2px rgba(15, 23, 42, 0.04)",
    "0px 2px 4px rgba(15, 23, 42, 0.06), 0px 1px 2px rgba(15, 23, 42, 0.04)",
    "0px 2px 6px rgba(15, 23, 42, 0.07), 0px 1px 3px rgba(15, 23, 42, 0.04)",
    "0px 3px 8px rgba(15, 23, 42, 0.08), 0px 1px 3px rgba(15, 23, 42, 0.04)",
    "0px 3px 8px rgba(15, 23, 42, 0.09), 0px 1px 4px rgba(15, 23, 42, 0.05)",
    "0px 4px 10px rgba(15, 23, 42, 0.10), 0px 1px 4px rgba(15, 23, 42, 0.05)",
    "0px 4px 12px rgba(15, 23, 42, 0.10), 0px 2px 4px rgba(15, 23, 42, 0.05)",
    "0px 5px 14px rgba(15, 23, 42, 0.11), 0px 2px 5px rgba(15, 23, 42, 0.05)",
    "0px 6px 16px rgba(15, 23, 42, 0.12), 0px 2px 6px rgba(15, 23, 42, 0.05)",
    "0px 7px 18px rgba(15, 23, 42, 0.12), 0px 3px 6px rgba(15, 23, 42, 0.06)",
    "0px 8px 20px rgba(15, 23, 42, 0.13), 0px 3px 7px rgba(15, 23, 42, 0.06)",
    "0px 9px 22px rgba(15, 23, 42, 0.14), 0px 3px 8px rgba(15, 23, 42, 0.06)",
    "0px 10px 24px rgba(15, 23, 42, 0.14), 0px 4px 8px rgba(15, 23, 42, 0.06)",
    "0px 11px 26px rgba(15, 23, 42, 0.15), 0px 4px 9px rgba(15, 23, 42, 0.06)",
    "0px 12px 28px rgba(15, 23, 42, 0.15), 0px 4px 10px rgba(15, 23, 42, 0.06)",
    "0px 13px 30px rgba(15, 23, 42, 0.16), 0px 5px 10px rgba(15, 23, 42, 0.06)",
    "0px 14px 32px rgba(15, 23, 42, 0.16), 0px 5px 11px rgba(15, 23, 42, 0.07)",
    "0px 16px 36px rgba(15, 23, 42, 0.17), 0px 6px 12px rgba(15, 23, 42, 0.07)",
    "0px 18px 40px rgba(15, 23, 42, 0.18), 0px 6px 14px rgba(15, 23, 42, 0.07)",
    "0px 20px 44px rgba(15, 23, 42, 0.18), 0px 7px 15px rgba(15, 23, 42, 0.07)",
    "0px 22px 48px rgba(15, 23, 42, 0.19), 0px 8px 16px rgba(15, 23, 42, 0.08)",
    "0px 24px 52px rgba(15, 23, 42, 0.20), 0px 8px 18px rgba(15, 23, 42, 0.08)",
  ];
  return ramps;
};

const themeOptions = {
  typography: {
    fontFamily: '"Inter", "Roboto", system-ui, sans-serif',
    fontSize: 14,

    h1: { fontSize: "2rem", fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: "1.5rem", fontWeight: 700, lineHeight: 1.25 },
    h3: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.35 },
    h5: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: "0.95rem", fontWeight: 600, lineHeight: 1.4, letterSpacing: "-0.01em" },

    subtitle1: { fontSize: "0.95rem", fontWeight: 500, lineHeight: 1.5 },
    subtitle2: { fontSize: "0.8125rem", fontWeight: 500, lineHeight: 1.5 },

    body1: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.8125rem", fontWeight: 400, lineHeight: 1.5 },

    button: { fontSize: "0.875rem", fontWeight: 600, textTransform: "none" },
    caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.5 },
    overline: {
      fontSize: "0.6875rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.08em",
    },
  },

  shape: { borderRadius: 12 },

  shadows: buildSoftShadows(),

  // Custom namespace. MUI v5 `createTheme` passes unknown top-level keys through
  // to the resolved theme, so `theme.app.*` is available at runtime in callbacks.
  // Palette tokens live ONLY in themeColors.js; nothing here sits under `palette`.
  app: {
    sidenavBg: "#F8FAFC",

    radius: { sm: 6, md: 12, lg: 16, xl: 24, pill: 999 },

    shadow: {
      card: "0 1px 2px rgba(15, 23, 42, 0.05), 0 2px 6px rgba(15, 23, 42, 0.06)",
      cardHover: "0 6px 16px rgba(15, 23, 42, 0.12)",
      popover: "0 10px 28px rgba(15, 23, 42, 0.14)",
      dialog: "0 16px 48px rgba(15, 23, 42, 0.18)",
    },
  },

  components: { ...components },
};

export default themeOptions;
